import * as React from 'react'
import { SafeAreaView, Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Tag from '@components/tag/Tag'
import ModalHeader from '@components/filter/ModalHeader'
import Button from '@components/button/Button'

import useI18n from '@i18n/useI18n'

interface Props {
  items: EDLFilter[]
  onSave: (items: EDLFilter[]) => void
  onReset: () => void
  onClose: () => void
}

const CATEGORIES: EDLFilter[] = ['TENANT', 'MANIFESTATION']
const TYPES: EDLFilter[] = ['IN', 'OUT']

const EDLFiltersMobile = ({ items, onSave, onReset, onClose }: Props) => {
  const i18n = useI18n()

  const [local, setLocal] = React.useState<EDLFilter[]>(items)

  React.useEffect(() => {
    setLocal(items)
  }, [items])

  const reset = () => {
    onReset()
    onClose()
  }

  const onApply = () => {
    onSave(local)
    onClose()
  }

  const onItemSelected = (item: EDLFilter) => {
    const selected = !!local.find((f) => f === item)

    if (selected) {
      setLocal(local.filter((f) => f !== item))
    } else {
      setLocal([...local, item])
    }
  }

  const renderItem = (item: EDLFilter) => {
    const selected = !!local.find((f) => f === item)

    return (
      <TagContainer key={item}>
        <Tag
          item={{ label: i18n.t(`screens.edlList.filters.${item}`), value: item }}
          onItemSelected={() => onItemSelected(item)}
          selected={selected}
          inactiveColor
        />
      </TagContainer>
    )
  }

  return (
    <MainContainer>
      <ModalHeader
        left={{ name: 'close', onClick: onClose }}
        title={i18n.t('screens.incidentList.filters.modal.main.title')}
        right={{ label: i18n.t('screens.incidentList.filters.modal.main.reset'), onClick: reset }}
      />

      <Content>
        {/* CATEGORIES */}
        <Section>
          <SectionTitle>{i18n.t('screens.edlList.tags.category')}</SectionTitle>
          <SectionBody>{CATEGORIES.map(renderItem)}</SectionBody>
        </Section>

        {/* TYPES */}
        <Section>
          <SectionTitle>{i18n.t('screens.edlList.tags.type')}</SectionTitle>
          <SectionBody>{TYPES.map(renderItem)}</SectionBody>
        </Section>
      </Content>

      <Footer>
        <Button label={i18n.t('screens.incidentList.filters.modal.button')} onClick={onApply} status="active" />
      </Footer>
    </MainContainer>
  )
}

export default EDLFiltersMobile

const MainContainer = styled(SafeAreaView)`
  flex: 1;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 30px;
`

const Section = styled(View)`
  margin-bottom: 32px;
`

const SectionTitle = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin-bottom: 8px;
`

const SectionBody = styled(View)`
  flex-direction: row;
`

const TagContainer = styled(View)`
  margin-right: 8px;
  margin-bottom: 8px;
  margin-top: 8px;
`

const Footer = styled(View)`
  padding: 16px 0;
`

const Content = styled(View)`
  flex: 1;
`
